import { sendLoginEvent, sendLogoutEvent } from '../../scripts/nativeApp';
import { isNativeApp } from '../isNativeApp/isNativeApp';

const NATIVE_LOGIN_EVENT = 'lottoland:native-login';
const NATIVE_LOGOUT_EVENT = 'lottoland:native-logout';

type NativeLoginEventDetail = {
  playerId?: string;
};

function handleNativeLogin(event: Event) {
  if (!(event instanceof CustomEvent)) return;

  const playerId = (event as CustomEvent<NativeLoginEventDetail>).detail?.playerId;
  if (!playerId) return;

  sendLoginEvent(playerId);
}

function handleNativeLogout() {
  sendLogoutEvent();
}

function subscribeNativeAuthEvents(): () => void {
  if (!isNativeApp()) {
    return () => {};
  }

  window.addEventListener(NATIVE_LOGIN_EVENT, handleNativeLogin);
  window.addEventListener(NATIVE_LOGOUT_EVENT, handleNativeLogout);

  return () => {
    window.removeEventListener(NATIVE_LOGIN_EVENT, handleNativeLogin);
    window.removeEventListener(NATIVE_LOGOUT_EVENT, handleNativeLogout);
  };
}

export { NATIVE_LOGIN_EVENT, NATIVE_LOGOUT_EVENT, subscribeNativeAuthEvents };
